// internationalization
import type { TFunction } from 'i18next';

// api
import type { CreateAlarmSubscriptionDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// libraries
import { z } from 'zod';

type Severity = NonNullable<CreateAlarmSubscriptionDto['FeedSeverity']>;

export const ALARM_GROUP_SEVERITY_LEVELS = [
  'Information',
  'Trivial',
  'Minor',
  'Medium',
  'Major',
  'Critical',
] as const satisfies readonly Severity[];

export function createAlarmGroupFormSchema(t: TFunction) {
  return z.object({
    groupName: z
      .string()
      .trim()
      .min(1, t('input.required', { ns: 'validation' })),
    users: z
      .array(
        z.object({
          user: z.string(),
          feedSeverity: z.enum(ALARM_GROUP_SEVERITY_LEVELS),
          emailSeverity: z.enum(ALARM_GROUP_SEVERITY_LEVELS),
        }),
      )
      .refine(
        (users) => users.some((user) => user.user.trim().length > 0),
        t('createAlarmGroup.atLeastOneUserRequired', { ns: 'forms' }),
      ),
    alarmTypes: z.array(z.number()),
  });
}

export type CreateAlarmGroupFormValues = z.infer<
  ReturnType<typeof createAlarmGroupFormSchema>
>;
